import React from "react";
import "../style.css";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";

const GovtResModal = ({ open, setOpen, tableData }) => {
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={open}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{"GST Response"}</Typography>
          <CloseIcon
            onClick={() => setOpen(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        {tableData ? (
          <div style={{ fontSize: "11px" }}>{tableData}</div>
        ) : (
          <div>'No Error'</div>
        )}

        <div></div>
      </MuiDialogContent>
    </Dialog>
  );
};

export default GovtResModal;
